"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _draftExtend = require("draft-extend");

var _react = _interopRequireDefault(require("react"));

var _constants = require("composer-plugins/lib/constants");

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _alignments = require("rich-text-lib/constants/alignments");

var _draftHelpers2 = require("../lib/draftHelpers");

var BLOCK_TYPE = 'atomic';
var ATOMIC_TYPE = _constants.ATOMIC_TYPES.image;
var DISPLAY_NAME = 'AdvancedImagePlugin';
var ENTITY_KEY = _constants.ENTITY_TYPES.image;

var _default = function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fileManagerUploadedFileAccess = options.fileManagerUploadedFileAccess,
      _options$imageButtonB = options.imageButtonBuilder,
      imageButtonBuilder = _options$imageButtonB === void 0 ? function () {
    return null;
  } : _options$imageButtonB,
      ImageComponent = options.ImageComponent;

  var blockRendererFn = function blockRendererFn(_ref) {
    var props = _ref.props;
    return function (currentBlock) {
      if (currentBlock.getType() !== BLOCK_TYPE) {
        return undefined;
      }

      var entity = (0, _draftHelpers.getDefaultEntity)(currentBlock, props.getEditorState().getCurrentContent().getEntity);

      if (entity && entity.getType() === ENTITY_KEY || currentBlock.getData().get('atomicType') === ATOMIC_TYPE) {
        return {
          component: ImageComponent,
          editable: false,
          props: Object.assign({}, props, {
            fileManagerUploadedFileAccess: fileManagerUploadedFileAccess
          })
        };
      }

      return undefined;
    };
  };

  var htmlToBlock = function htmlToBlock(nodeName, node, lastList, inBlock) {
    if (nodeName === 'figure' && node.firstChild.nodeName === 'IMG' || nodeName === 'img' && inBlock !== 'atomic') {
      var nodeClassName = node.getAttribute('class');
      var alignment = _alignments.Alignments.CENTER;

      if (nodeClassName.indexOf('align-none') > -1) {
        alignment = _alignments.Alignments.NONE;
      } else if (nodeClassName.indexOf('align-left') > -1) {
        alignment = _alignments.Alignments.LEFT;
      } else if (nodeClassName.indexOf('align-right') > -1) {
        alignment = _alignments.Alignments.RIGHT;
      }

      return {
        type: BLOCK_TYPE,
        data: {
          alignment: alignment,
          atomicType: ATOMIC_TYPE,
          name: node.getAttribute('alt'),
          src: node.getAttribute('src')
        }
      };
    }

    return undefined;
  };

  var blockToHTML = function blockToHTML(block) {
    var type = block.type,
        data = block.data;
    var alignment = data.alignment,
        atomicType = data.atomicType,
        linkData = data.linkData,
        name = data.name,
        src = data.src;

    if (type !== BLOCK_TYPE || atomicType !== ATOMIC_TYPE) {
      return undefined;
    }

    var figureClassName;
    var imgStyle = {};

    switch (alignment) {
      case _alignments.Alignments.NONE:
        figureClassName = 'hs-align-none';
        break;

      case _alignments.Alignments.CENTER:
        figureClassName = 'hs-align-center';
        break;

      case _alignments.Alignments.LEFT:
        figureClassName = 'hs-align-left';
        imgStyle.margin = 0;
        break;

      case _alignments.Alignments.RIGHT:
        figureClassName = 'hs-align-right';
        imgStyle.margin = 0;
        break;

      default:
        break;
    }

    var img = _react.default.createElement("img", {
      src: src,
      alt: name,
      style: imgStyle
    });

    if (linkData && linkData.href && linkData.href !== '') {
      var externalLink = linkData.externalLink,
          noFollow = linkData.noFollow,
          href = linkData.href;
      var target = externalLink ? '_blank' : '_self';
      var rel = noFollow ? 'nofollow' : null;
      img = _react.default.createElement("a", {
        href: href,
        target: target,
        rel: rel
      }, img);
    }

    return _react.default.createElement("figure", {
      className: figureClassName
    }, img);
  }; // skip over left-/right-aligned images on backspace


  var keyCommandListener = function keyCommandListener(editorState, command) {
    if (['backspace', 'delete-image'].indexOf(command) === -1) {
      return undefined;
    }

    return (0, _draftHelpers2.deleteImageBlock)(editorState);
  };

  return (0, _draftExtend.createPlugin)({
    displayName: DISPLAY_NAME,
    buttons: imageButtonBuilder(fileManagerUploadedFileAccess),
    blockRendererFn: blockRendererFn(options),
    htmlToBlock: htmlToBlock,
    blockToHTML: blockToHTML,
    keyCommandListener: keyCommandListener
  });
};

exports.default = _default;
module.exports = exports.default;